<template>
  <div class="login-container">

    <div class="login-box">
      <div class="logo-container">
        <img src="@/assets/img/logo.jpg" alt="LaplaceMate" class="logo-img" />
      </div>
      <h1 class="login-title">{{ $t('login.title') }}</h1>

      <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          @keyup.enter.native="handleLogin"
      >
        <!-- 账号输入框 -->
        <el-form-item prop="userName">
          <el-input
              v-model="loginForm.userName"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>

        <!-- 密码输入框 -->
        <el-form-item prop="password">
          <el-input
              v-model="loginForm.password"
              type="password"
              :placeholder="$t('login.passwordPlaceholder')"
              prefix-icon="el-icon-lock"
              show-password
          ></el-input>
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item>
          <el-button
              type="primary"
              class="login-btn"
              :loading="loading"
              @click="handleLogin"
          >
            {{ $t('login.login') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      loginForm: {
        userName: '',    // 账号
        password: ''  // 密码
      },
      loading: false        // 登录按钮加载状态
    }
  },
  computed: {
    // 动态验证规则
    loginRules() {
      return {
        userName: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: this.$t('login.passwordRequired'), trigger: 'blur'},
          {min: 6, max: 20, message: this.$t('login.passwordLengthError'), trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 处理登录
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 密码登录接口
          this.$api.auth.loginAdmin({
            userName: this.loginForm.userName,
            password: this.loginForm.password
          }).then(res => {
            this.handleLoginSuccess(res)
          }).catch(err => {
            this.handleLoginError(err)
          }).finally(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },

    // 登录成功统一处理
    handleLoginSuccess(res) {
      console.log(res)
      if (res.statusCode === 100200) {
        this.$store.commit("setUser", res.data)
        this.$store.commit("setUserId", res.data.id ? String(res.data.id) : '')
        this.$store.commit("setIsAdmin", true)
        this.$message.success(this.$t('login.loginSuccess'))
        this.$router.push('/home/systemRoles')
        // 重置表单
        this.$refs.loginForm.resetFields()
      } else {
        this.$message.error(this.$t('login.loginError'))
      }
    },

    // 登录错误统一处理
    handleLoginError(err) {
      console.error('登录出错:', err)
      // 如果是业务错误，使用国际化提示；如果是网络错误，使用网络错误提示
      if (err.isBusinessError) {
        this.$message.error(this.$t('login.loginError'))
      } else {
        this.$message.error(this.$t('login.networkError'))
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  background-size: cover;
  background-image: url("@/assets/index/bc.jpg");
  background-position: center;
  position: relative;
}



.login-box {
  width: 90%;
  max-width: 400px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.logo-img {
  max-width: 200px;
  height: auto;
  object-fit: contain;
}

.login-title {
  margin-bottom: 20px;
  text-align: center;
  color: #333;
  font-size: 24px;
}

.login-form {
  margin-bottom: 20px;
}

.login-btn {
  width: 100%;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .login-box {
    width: 85%;
    padding: 20px;
  }

  .login-title {
    font-size: 20px;
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  .login-box {
    width: 90%;
    padding: 15px;
  }

  .login-title {
    font-size: 18px;
  }
}
</style>
